import { UseQueryResult } from '@tanstack/react-query';
import { endPointUrls } from 'core/constants/endPointUrls';
import api from 'core/services/fetch-api/useApi';
import useQueryUrlParam from 'core/hooks/useQueryUrlParam';
import useQueryHook from 'core/hooks/masterQuery/useQueryHook';
import { IInvoiceList } from 'core/types/models/invoiceType';

export const useUserInvoiceTableQuery = () => {
	const { filterParams } = useQueryUrlParam();

	return useQueryHook(
		[endPointUrls.PAYMENT_INVOICES_ALL(), filterParams],
		(data: any) => api.get(endPointUrls.PAYMENT_INVOICES_ALL(filterParams), data),
		{
			select: (res: any) => res?.data,
			keepPreviousData: true,
		}
	) as UseQueryResult<IInvoiceList, Error>;
};
